import * as React from 'react';
import DialogActions from '@material-ui/core/DialogActions';
import Button from '@material-ui/core/Button';
import NotificationImportantIcon from '@material-ui/icons/NotificationImportant';
import Modal from '../Modal';
import { getShopifyParams } from '../../utils';
import { makeStyles } from '@material-ui/core';

const useStyles = makeStyles((theme) => ({
  actions: {
    display: 'flex',
    justifyContent: 'center',
    marginBottom: theme.spacing(2),
  },
}));

export default function SwitchShopDialog(props) {
  const { open, handleClose, handleSwitch } = props;
  const classes = useStyles();

  const params = getShopifyParams();

  const onClose = () => {
    handleClose();
  };

  const onSignOut = async () => {
    await handleSwitch();
  };

  return (
    <Modal
      open={open}
      onClose={handleClose}
      width={470}
      icon={NotificationImportantIcon}
      iconColor="draft"
      iconMarginLeft={-40}
      title={<b>Switch to a different store?</b>}
      text={
        <>
          This account is already connected to a different Shopify store.
          <br />
          To connect to <b>{params?.shop || 'a new store'}</b> sign out and then
          sign up with a new account (or sign in with a different account
          already connected to this store).
        </>
      }
    >
      <DialogActions className={classes.actions}>
        <Button
          onClick={onSignOut}
          color="primary"
          variant="contained"
          type="submit"
        >
          Sign Out
        </Button>
        <Button onClick={onClose}>Continue With Current</Button>
      </DialogActions>
    </Modal>
  );
}
